import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { when } from 'mobx';
import { Modal } from 'react-bootstrap';
import CreateInvoiceComponent from '../components/create-invoice-component';

@inject('appStore')
@observer
export default class InvoiceFileModal extends Component {
    constructor(props) {
        super(props);
    }

    handleInvoiceCreated() {
        appStore.viewStore.hideInvoiceFileDialogModal();
    }

    render() {
        return (
            <Modal
                show={appStore.viewStore.invoiceFileDialogOpen}
                onHide={appStore.viewStore.hideInvoiceFileDialogModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="">Create Invoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CreateInvoiceComponent handleInvoiceCreated={this.props.handleInvoiceCreated} />
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/files/invoice-form-modal.js